<template>
    <div class="logo-container">
        <img
            v-if="!whitelabelConfig"
            v-svg-inline
            :src="ASSETS_URL + 'app_logo.svg'"
            style="max-width: 100%; max-height: 100%;"
        />
        <img
            v-else
            :src="whitelabelConfig && whitelabelConfig.logoUrl"
            style="max-width: 100%; max-height: 100%;"
        />
    </div>

</template>
<script>
import { ASSETS_URL } from '@/constants/misc'

export default {
    name: 'logo',
    props: {
        whitelabelConfig: {
            type: Object
        }
    },
    data() {
        return {
            ASSETS_URL
        }
    },
}

</script>
<style lang="scss">
.logo-container {
    max-height: 390px; 
    max-width: 390px;
}
</style>